import { ShortFormContentList } from '@domains/pdp-common';

import { ShortClipModel } from './types';

export function toShortClipContentList(list: Array<ShortFormContentList>) {
  return list.map(toShortClipContent);
}

export function toShortClipContent(data: ShortFormContentList): ShortClipModel {
  return {
    id: data?.id || '',
    title: data?.title || '',
    thumbnail_image_url: data?.thumbnail_image_url || '',
    video_url: data?.video_url || '',
  };
}
